'use client'

import Image from 'next/image'
import { Building2 } from 'lucide-react'
import type { CrmProviderType } from '@/lib/crm/types'
import { useTranslations } from "next-intl"


interface CrmProviderLogoProps {
  provider: CrmProviderType
  logoUrl?: string
  size?: number
  className?: string
}

/**
 * Renders the logo for a CRM provider.
 * Falls back to a generic icon if logo is not available.
 */
export function CrmProviderLogo({ provider, logoUrl, size = 24, className }: CrmProviderLogoProps) {
  const tUi = useTranslations("Crm.CrmCrmProviderLogo")

  if (logoUrl) {
    return (
      <Image
        src={logoUrl}
        alt={tUi("value0Logo", { value0: String(provider) })}
        width={size}
        height={size}
        className={className}
      />
    )
  }

  // Fallback to generic icon
  return <Building2 className={className} style={{ width: size, height: size }} />
}
